import type { Group } from "@/group";
import { t } from "@/i18n";
import { showSnackbar } from "@/snackbar/snackbar";
import { SNACKBAR_TIMEOUT } from "../constants/aiConstants";
import { processSelectedWidgets } from "./processSelectedWidgets";

export function getWidgetsForAi(widgets: Group[]) {
    const { widgetUIDs } = processSelectedWidgets(widgets, "create");

    if (!widgetUIDs.length) {
        showSnackbar(t("ai.notEnoughText"), { duration: SNACKBAR_TIMEOUT });
    }

    return widgetUIDs;
}
